import React from 'react';
import { components as SelectComponents, OptionProps } from 'react-select';
import { truncate } from 'src/components/truncate/truncate';
import styled from 'styled-components';
import { DemiBold, Regular } from '../../../styles/fonts';
import { ISelected } from './ship-to-customer-search';

const TextPrimary = styled.div`
  font-family: ${DemiBold};
  vertical-align: bottom;
  text-transform: uppercase;
  ${truncate};
`;

const TextBody = styled.div`
  font-family: ${Regular};
  text-transform: uppercase;
  ${truncate};
`;

export const Option = (props: OptionProps<ISelected>) => {
  const { data } = props;
  const { value, label } = data;
  return (
    <SelectComponents.Option {...props}>
      <div data-type="option">
        <div>
          <TextPrimary data-type="option-label" data-value={label}>
            {label}
          </TextPrimary>
          <TextBody data-type="option-id">{value}</TextBody>
        </div>
      </div>
    </SelectComponents.Option>
  );
};
